import { useContext } from 'react';
import { useRouter } from 'next/router';
import { Button } from '@components/ButtonV2';
import Spinner from '@components/Spinner';
import {
  Bundle,
  ItemTypeKind,
  useAddWaitingItemMutation,
  useBundleLazyQuery,
} from '@gql/generated';
import { UserContext } from '@lib/contexts/UserProvider';
import LanguageContext from '@lib/contexts/languageContext';
import { Trans } from '@lingui/react';
import AnalyticsManager from '@lib/analytics/manager';

// type RequiredFields<T, K extends keyof T> = Partial<T> & Required<Pick<T, K>>;
type Props = {
  bundle: Pick<Bundle, 'id' | 'title' | 'bundleCategory' | 'slug'> & {
    client_name: string;
  };
  onJoin?(): void;
};

export const JoinBundleWaitlist = (props: Props) => {
  const { bundle } = props;
  const router = useRouter();
  const lang = useContext(LanguageContext);
  const [curentUser] = useContext(UserContext);
  const { client, slug } = router.query;
  const [, { loading: bundleLoading, refetch }] = useBundleLazyQuery({
    variables: {
      client: client as string,
      slug: slug as string,
    },
  });
  const [joinWaitlist, { loading }] = useAddWaitingItemMutation({
    onCompleted() {
      AnalyticsManager().sendJoinedBundleWaitList({
        name: bundle?.title,
        slug: bundle?.slug,
        client_name: bundle?.client_name,
        category: bundle?.bundleCategory,
      });
      refetch();

      if (typeof props.onJoin === 'function') {
        props.onJoin();
      }
    },
  });

  const onClick = () => {
    if (!curentUser?.id) {
      const url = `/${lang}/c/${client}/b/${slug}/get-started`;
      router.push({
        pathname: `/${lang}/register/account`,
        query: {
          to: url,
        },
      });
    } else {
      joinWaitlist({
        variables: {
          itemId: bundle?.id,
          itemType: ItemTypeKind['Bundle'],
        },
      });
    }
  };

  return (
    <Button onClick={onClick} disabled={loading || bundleLoading}>
      {loading || bundleLoading ? (
        <Spinner />
      ) : (
        <Trans id="bundle.id_page.join_waiting_list_btn" />
      )}
    </Button>
  );
};
